export default "__VITE_ASSET__CxyeRuVz__"